/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetOdometerResponse } from '../models/ApiResponseGetOdometerResponse';
import type { StopRequest } from '../models/StopRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EcoMileageExternalControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 서울시 에코마일리지 연동 철회 (서울시 -> DI)
   * 서울시 에코마일리지 회원탈퇴정보 전달
   * @returns ApiResponseGetOdometerResponse OK
   * @throws ApiError
   */
  public handleExternalWithdrawal({
    carId,
    requestBody,
  }: {
    carId: string,
    requestBody: StopRequest,
  }): CancelablePromise<ApiResponseGetOdometerResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/external/seoul-ecomileage/{carId}/stop/',
      path: {
        'carId': carId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 서울시 에코마일리지 연동 철회 (서울시 -> DI)
   * 서울시 에코마일리지 회원탈퇴정보 전달
   * @returns ApiResponseGetOdometerResponse OK
   * @throws ApiError
   */
  public handleExternalWithdrawal1({
    carId,
    requestBody,
  }: {
    carId: string,
    requestBody: StopRequest,
  }): CancelablePromise<ApiResponseGetOdometerResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/external/seoul-ecomileage/{carId}/stop',
      path: {
        'carId': carId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * 누적주행거리 조회 (서울시 -> DI)
   * 서울시에서 마일리지 지급을 위한 누적주행거리 조회시 호출
   * @returns ApiResponseGetOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer2({
    carId,
  }: {
    carId: string,
  }): CancelablePromise<ApiResponseGetOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/external/seoul-ecomileage/{carId}/odometer/',
      path: {
        'carId': carId,
      },
    });
  }
  /**
   * 누적주행거리 조회 (서울시 -> DI)
   * 서울시에서 마일리지 지급을 위한 누적주행거리 조회시 호출
   * @returns ApiResponseGetOdometerResponse OK
   * @throws ApiError
   */
  public getOdometer3({
    carId,
  }: {
    carId: string,
  }): CancelablePromise<ApiResponseGetOdometerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/external/seoul-ecomileage/{carId}/odometer',
      path: {
        'carId': carId,
      },
    });
  }
}
